{
  "title": "Evidence-backed assistance directions",
  "observedDate": "2026-07-15",
  "priorities": [
    {
      "priority": 1,
      "theme": "Recruit and retain family foster carers",
      "problemSignal": "NIK identified a persistent shortage of candidates and insufficient support for existing foster families as the dominant barrier to expanding family care.",
      "firstAssistance": "Fund locally designed recruitment funnels; offer practical onboarding, peer mentoring, and retention support through PCPR/organizers.",
      "validationMetric": "qualified candidates, conversion to approved carers, 12-month retention, reasons for withdrawal",
      "evidenceUrl": "https://www.nik.gov.pl/najnowsze-informacje-o-wynikach-kontroli/deinstytucjonalizacji-pieczy-zastepczej.html"
    },
    {
      "priority": 2,
      "theme": "Specialist mental-health, therapy, and rehabilitation access",
      "problemSignal": "NIK reported growing complexity of children's needs and limited access to specialists, especially child psychiatrists, therapists, and rehabilitation.",
      "firstAssistance": "Purchase time-limited specialist capacity, travel/telehealth support, and care-navigation services based on confirmed referrals from authorized care teams.",
      "validationMetric": "wait time, completed specialist visits, care-plan completion, caregiver-reported access barriers",
      "evidenceUrl": "https://www.nik.gov.pl/aktualnosci/deinstytucjonalizacji-pieczy-zastepczej.html"
    },
    {
      "priority": 3,
      "theme": "Respite, coordinator, peer, and volunteer support",
      "problemSignal": "Official duties include training, support groups, volunteer help, counseling, therapy, and legal assistance; NIK found uneven coordinator coverage and limited effectiveness measurement.",
      "firstAssistance": "Backfill respite and trusted-volunteer capacity through organizers, strengthen peer groups, and fund simple service-level tracking rather than collecting household identities.",
      "validationMetric": "families served, respite hours, coordinator caseload, service uptake, unmet requests",
      "evidenceUrl": "https://www.nik.gov.pl/aktualnosci/sprawy-spoleczne/rodzinna-piecza-zastepcza.html"
    },
    {
      "priority": 4,
      "theme": "Transition to adulthood: housing, work, and durable relationships",
      "problemSignal": "NIK found support for care leavers focused heavily on the easiest cash benefits while housing and employment assistance remained weak or inconsistently evidenced.",
      "firstAssistance": "Create opt-in transition cohorts with housing navigation, paid work experience, mentoring, documentation help, and 24-month follow-up.",
      "validationMetric": "stable housing, employment/education status, income continuity, trusted-adult connection at 6/12/24 months",
      "evidenceUrl": "https://www.nik.gov.pl/najnowsze-informacje-o-wynikach-kontroli/placowki-opiekunczo-wychowawcze-piecza-zastepcza-usamodzielnienie.html"
    },
    {
      "priority": 5,
      "theme": "Specialized family care for children with disabilities",
      "problemSignal": "A 2026 NIK review found too few specialist foster families and barriers spanning staffing, health, education, respite, funding, and coordination.",
      "firstAssistance": "Support specialized foster-carer recruitment, home adaptation, equipment, respite, coordinated clinical access, and caregiver training through authorized local partners.",
      "validationMetric": "specialist placements created, avoided inappropriate institutional placements, respite availability, service wait times",
      "evidenceUrl": "https://www.nik.gov.pl/aktualnosci/sprawy-spoleczne/dps-nie-tylko-dla-dzieci-i-mlodziezy.html"
    },
    {
      "priority": 6,
      "theme": "Confirmed material, education, and technology needs",
      "problemSignal": "Material needs can be real but change quickly and cannot be inferred reliably from public registers.",
      "firstAssistance": "Run a short, consent-based needs survey through facility leadership and PCPR/organizers; fulfill standardized wish lists with delivery confirmation and safeguarding rules.",
      "validationMetric": "verified requests, fulfillment rate, delivery time, recipient confirmation, repeat unmet needs",
      "evidenceUrl": "https://www.gov.pl/web/rodzina/piecza-zastepcza-potrzebny-komputer-lub-oprogramowanie-mozesz-liczyc-na-wsparcie"
    }
  ]
}

